import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import Api from "../../utils/api";
export function getLoans(_x) {
  return _getLoans.apply(this, arguments);
}
function _getLoans() {
  _getLoans = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var state,
      commit,
      fresh,
      _yield$Api$get,
      data,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          state = _ref.state, commit = _ref.commit;
          fresh = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
          if (!(state.loans && !fresh)) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", state.loans);
        case 1:
          _context.next = 2;
          return Api().get('api/loans');
        case 2:
          _yield$Api$get = _context.sent;
          data = _yield$Api$get.data;
          commit('loans/setLoans', data, {
            root: true
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getLoans.apply(this, arguments);
}
export function payDueRepayment(_x2, _x3) {
  return _payDueRepayment.apply(this, arguments);
}
function _payDueRepayment() {
  _payDueRepayment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, params) {
    var state, commit;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          state = _ref2.state, commit = _ref2.commit;
          _context2.next = 1;
          return Api().post('api/pay-due-repayment', params);
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _payDueRepayment.apply(this, arguments);
}
export function payPartialRepayment(_x4, _x5) {
  return _payPartialRepayment.apply(this, arguments);
}
function _payPartialRepayment() {
  _payPartialRepayment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, params) {
    var state, commit;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          state = _ref3.state, commit = _ref3.commit;
          _context3.next = 1;
          return Api().post('api/pay-partial-repayment', params);
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _payPartialRepayment.apply(this, arguments);
}
export function payEarlySettlement(_x6, _x7) {
  return _payEarlySettlement.apply(this, arguments);
}
function _payEarlySettlement() {
  _payEarlySettlement = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4, params) {
    var state, commit;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          state = _ref4.state, commit = _ref4.commit;
          _context4.next = 1;
          return Api().post('api/pay-early-settlement', params);
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _payEarlySettlement.apply(this, arguments);
}
export function createPayplan(_x8, _x9) {
  return _createPayplan.apply(this, arguments);
}
function _createPayplan() {
  _createPayplan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5, params) {
    var state, commit;
    return _regeneratorRuntime.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          state = _ref5.state, commit = _ref5.commit;
          _context5.next = 1;
          return Api().post("api/loan/".concat(params.loan_id, "/preset/").concat(params.preset_id), {
            params: params.params
          });
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _createPayplan.apply(this, arguments);
}
export function sendRepayments(_x0) {
  return _sendRepayments.apply(this, arguments);
}
function _sendRepayments() {
  _sendRepayments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref6) {
    var state, _yield$Api$post, data;
    return _regeneratorRuntime.wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          state = _ref6.state;
          _context6.next = 1;
          return Api().post('api/send-repayments');
        case 1:
          _yield$Api$post = _context6.sent;
          data = _yield$Api$post.data;
          return _context6.abrupt("return", data);
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _sendRepayments.apply(this, arguments);
}